export const TESTCASES_LABEL_READONLY = 'Sample Tests';
export const TESTCASES_LABEL_READWRITE =
  TESTCASES_LABEL_READONLY + ' (Modifiable)';

export const CLASSIC_CHALLENGE_LAYOUT_PROPS = {
  code: {
    label: 'Your Solution',
    tabTooltip: 'Input your solution here',
    tabset: 'topLeft',
    tabindex: 1,
    active: true,
  },
  testcases: {
    label: TESTCASES_LABEL_READWRITE,
    tabTooltip:
      'Modify or add test cases to validate your solution before submitting',
    tabset: 'bottomLeft',
    tabindex: 1,
    active: true,
    get smallWindow() {
      return {
        tabset: 'topLeft',
        tabindex: 2,
        active: false,
      };
    },
  },
  instructions: {
    tabset: 'topRight',
    tabindex: 1,
    active: true,
  },
  candidatenotes: {
    tabset: 'topRight',
    tabindex: 2,
  },
  help: {
    tabset: 'topRight',
    tabindex: 3,
  },
  interactparticipants: {
    tabset: 'topRight',
    tabindex: 4,
  },
  idesettings: {
    tabset: 'topRight',
    tabindex: 5,
  },
  runnerframe: {
    tabset: 'bottomRight',
    tabindex: 1,
    active: true,
  },
};

export const CLASSIC_CODE_CHALLENGE_LAYOUT_PREVIEW = {
  challenge$solution: {
    label: 'Reference Solution',
    tabTooltip: 'The reference solution (never shown to candidates)',
    tabset: 'topLeft',
    tabindex: 3,
  },
  challengeTestCasesProtected: {
    tabindex: 5,
  },
  challenge$testcases: {
    label: 'Test Cases',
    tabTooltip: 'The submission test cases (never shown to candidates)',
    tabset: 'topRight',
    tabindex: 5,
  },
  challenge$preloaded: {
    label: 'Preloaded Code',
    tabTooltip:
      'Boilerplate code preloaded to make solving easier (not shown to candidates)',
    tabset: 'topRight',
    tabindex: 6,
  },
  idesettings: {
    tabindex: 7,
  },
};

export const CLASSIC_CODE_CHALLENGE_LAYOUT_INTERACT = {
  code: {
    label: `Candidate's Solution`,
    tabTooltip: 'Edit the solution alongside the candidate',
  },
  testcases: {
    label: "Candidate's Tests",
    tabTooltip: 'Edit the test cases alongside the candidate',
  },
  challenge$solution: {
    label: 'Reference Solution',
    tabTooltip: 'The reference solution (hidden from the candidate)',
    tabset: 'topLeft',
    tabindex: 3,
  },
  challengeTestCasesProtected: {
    tabindex: 5,
  },
  challenge$testcases: {
    label: 'Test Cases',
    tabTooltip: 'The submission test cases (hidden from the candidate)',
    tabset: 'topRight',
    tabindex: 5,
  },
  challenge$preloaded: {
    label: 'Preloaded Code',
    tabTooltip:
      'Boilerplate code preloaded to make solving easier (hidden from the candidate)',
    tabset: 'topRight',
    tabindex: 6,
  },
  codeCompare: {
    tabindex: 7,
  },
  reviews: {
    tabindex: 8,
  },
  idesettings: {
    tabindex: 9,
  },
  interactparticipants: {
    tabindex: 10,
  },
};

export function configureClassicCodeOpenFiles(
  ctrl,
  $window,
  additionaLayoutProps,
) {
  const smallWindow = angular.element($window).offsetHeight() < 800;
  const openableFiles = [
    ...ctrl.mfc.files,
    ...ctrl.referenceFiles,
    ...ctrl.mfc.challengeEditorTools,
    ...ctrl.mfc.challengeConfig,
  ];
  const layoutProps = angular.merge(
    {},
    CLASSIC_CHALLENGE_LAYOUT_PROPS,
    additionaLayoutProps,
  );

  const challengeProps = {
    code: {
      readOnly() {
        return !!ctrl.expired;
      },
    },
    testcases: {
      readOnly() {
        return !!(
          ctrl.expired ||
          (ctrl.challenge && ctrl.challenge.sampleTestCasesReadOnly)
        );
      },
      disabled() {
        return !ctrl.challenge || !ctrl.challenge.sampleTestCasesEnabled;
      },
      label() {
        return this.readOnly
          ? TESTCASES_LABEL_READONLY
          : TESTCASES_LABEL_READWRITE;
      },
    },
    challenge$solution: {
      disabled() {
        return !!(ctrl.challenge && ctrl.challenge.protected);
      },
    },
    challenge$testcases: {
      disabled() {
        return !!(ctrl.challenge && ctrl.challenge.protected);
      },
    },
    challenge$preloaded: {
      disabled() {
        return !!(ctrl.challenge && ctrl.challenge.protected) || !this.contents;
      },
    },
  };

  return Object.entries(layoutProps)
    .map(([id, props]) => {
      const file = openableFiles.find((f) => f.id === id || f.path === id);
      if (file) {
        const layoutProps = Object.assign(
          {},
          props,
          (smallWindow && props.smallWindow) || {},
        );
        Object.assign(file, layoutProps);
        if (challengeProps[file.id]) {
          Object.entries(challengeProps[file.id]).forEach(([id, get]) => {
            Object.defineProperty(file, id, { get, configurable: true });
          });
        }
      }
      return file;
    })
    .filter((f) => f && !f.disabled);
}
